export default __webpack_public_path__ + "static/media/square-close.be83fc8f.svg";